
export const AuthDretsImatge = ({auth, handleChange, error }) => 
{

return (<div className="row">
        <div className="col col-12 ">
        <h4>
            Autorització relativa a l'ús d'imatges i publicació de dades
        </h4>
        <p>
            El centre disposa d’espais de comunicació i difusió, inclosos els espais web (adreça o adreces web), on informa i fa difusió de les 
            activitats escolars lectives, complementàries i extraescolars. En aquests espais es poden publicar imatges/veu en què apareguin, individualment o en grup, 
            alumnes que fan les activitats esmentades. El dret a la pròpia imatge és reconegut en l’article 18.1 de la Constitució espanyola i està regulat per la 
            Llei orgànica 1/1982, de 5 de maig, sobre el dret a l’honor, a la intimitat personal i familiar i a la pròpia imatge, per la qual cosa la 
            direcció d’aquest centre demana el consentiment per publicar fotografies i vídeos on surtin l'alumne/a clarament identificables.  
        </p>

        <p>
            <input type="checkbox" id="authDretsImatge" name="authDretsImatge" value={auth} checked={auth === "1" ? true : false } onChange={ (t) => { handleChange(t.target.value) } } required/>
            <label htmlFor="authDretsImatge"> Autoritzo que la imatge i/o veu del meu fill/a, o jo mateix com a alumne/a major d'edat, pugui aparèixer en 
                fotografies, vídeos i àudios captades durant la realització d'activitats escolars o extraescolars que hagin estat organitzades per 
                l'Institut de Badia del Vallès, i que aquestes puguin publicar-se als diferents canals de comunicació del centre.</label>
            <span id="auhtDretsImatge_ERROR" className="a-Form-error">{error}</span>
        </p>


        </div>
    </div>)
}